import React, { useState, useEffect } from "react";
import { Button} from "@material-ui/core";
import { LoanRequestsList, ApproveRequest,RejectRequest} from "./loanRequestsList-api";
//auth
import "./style.css";
import auth from "../../auth/auth-helper";

export default function LoanRequests() {
  const [loanRequests, setLoanRequests] = useState([]);

  useEffect(() => {
    const abortController = new AbortController();
    const signal = abortController.signal;
    const credentials = auth.isAuthenticated();

    LoanRequestsList(signal, credentials).then((res) => {
      if (res.status === 200) {
        console.log("token here ....................." + credentials);
        // console.log(res.status);
        console.log(res);
        //console.log(res.statusCode);
        setLoanRequests(res.response[0]);
      } else {
      }
    });

    return function cleanup() {
      abortController.abort();
    };
  }, []);

  const renderHeader = () => {
    let headerElement = [
      "Account No",
      "Amount",
      "Installment",
      "Date",
      "Customer Name",
      "Period",
      "Status",
      "Loan Type",
      "ID",
    ];

    return headerElement.map((key, index) => {
      return <th key={index}>{key.toUpperCase()}</th>;
    });
  };

  const renderBody = () => {
    return (
      loanRequests &&
      loanRequests.map(
        ({
          account_no,
          amount,
          installment,
          requested_date,
          requested_by,
          time_period,
          loan_status,
          loan_type,
          loan_id,
        }) => {
          return (
            <tr key={loan_id}>
              <td>{account_no}</td>
              <td>{amount}</td>
              <td>{installment}</td>
              <td>{requested_date}</td>
              <td>{requested_by}</td>
              <td>{time_period}</td>
              <td>{loan_status}</td>
              <td>{loan_type}</td>
              <td>{loan_id}</td>
              <td className="opration">
                <Button
                  className="button"
                  variant="contained"
                  color="primary"
                  onClick={() =>
                    ApproveRequest(auth.isAuthenticated(), loan_id)
                  }
                >
                  Approve
                </Button>
                <br></br>
                <br></br>
                <Button
                  className="button"
                  variant="contained"
                  color="secondary"
                  onClick={() =>
                    RejectRequest(auth.isAuthenticated(), loan_id)
                  }
                >
                  Reject
                </Button>
              </td>
            </tr>
          );
        },
      )
    );
  };
  return (
    <>
      <h1 id="title">Approve</h1>
      <table id="employee">
        <thead>
          <tr>{renderHeader()}</tr>
        </thead>
        <tbody>{renderBody()}</tbody>
      </table>
    </>
  );
}
